let key = {};
let env = "production";
// export const API_URL = "http://localhost:2026";
// export const API_URL = "https://sector8-backend.maticz.in/";//demo
export const API_URL = "https://api.sector-8.ch";//live
// export const API_URL = "https://api.sector-8.ch";


// export const PORT = 2038;
// if (process.env.NODE_ENV === "production") {
if (env === "production") {
  console.log("Set Production Config");
  // const API_URL = "https://api.flashchainbot.com";
  const API_URL = "https://api.sector-8.ch";

  key = {
    secretOrKey: "vOVH6sdmpNWjRRIqCc7rdxs01lwHzfr3",
    CRYPTO_SECRET_KEY: "1234567812345678",
    Recaptchakey: "6LeHezUfAAAAAE_uuY_HFN5HoEVsQv8bpyC3xTat", //local
    API_URL: API_URL,
    FRONT_URL: "https://test.sector-8.ch",
    ADMIN_URL: "https://test-admin.sector-8.ch/",
    getGeoInfo: "https://ipapi.co/json/",
  };
} else if (env === "demo") {
  console.log("Set Demo Config");
  const API_URL = "https://sector8-backend.maticz.in/";

  key = {
    secretOrKey: "vOVH6sdmpNWjRRIqCc7rdxs01lwHzfr3",
    CRYPTO_SECRET_KEY: "1234567812345678",
    Recaptchakey: "6LeHezUfAAAAAE_uuY_HFN5HoEVsQv8bpyC3xTat", //local
    API_URL: API_URL,
    FRONT_URL: "https://flashloan.maticz.in/",
    ADMIN_URL: "https://flashloan-admin.maticz.in",
    getGeoInfo: "https://ipapi.co/json/",
  };
} else {
  console.log("Set Development Config");
  const API_URL = "http://localhost";
  key = {
    secretOrKey: "vOVH6sdmpNWjRRIqCc7rdxs01lwHzfr3",
    CRYPTO_SECRET_KEY: "1234567812345678",
    Recaptchakey: "6LeHezUfAAAAAE_uuY_HFN5HoEVsQv8bpyC3xTat", //local
    API_URL: `${API_URL}:2026`,
    FRONT_URL: "http://localhost",
    ADMIN_URL: "http://localhost:3001/admin",
    getGeoInfo: "https://ipapi.co/json/",
  };
}

export default key;
